import { Component, OnInit } from "@angular/core";
import { ToasterService } from "angular2-toaster";
import {
  FeedbackConfig,
  FeedbackModal,
  FeedbackType,
} from "app/feedback/models/feedback-config.model";
import { FeedbackService } from "app/feedback/services/feedback.service";
import { BsModalRef } from "ngx-bootstrap";

@Component({
  selector: "app-feedback",
  templateUrl: "./feedback.component.html",
  styleUrls: ["./feedback.component.scss"],
})
export class FeedbackComponent implements OnInit, FeedbackConfig {
  type: FeedbackType;
  modal: FeedbackModal;
  extraFeedbackValues?: any[];
  closeLabel: string = "Close";

  constructor(
    public bsModalRef: BsModalRef,
    private toasterService: ToasterService
  ) { }

  ngOnInit() { }
}
